import ApiService from "../apiService";

class AuthService {
  static async login(element) {
    const result = await ApiService.post("/login", element);
    return result.data;
  }

  /**
   * Cambia la contraseña de un usuario con contraseña vencida (AD 532/773).
   * Si el cambio es exitoso el backend hace el login automáticamente y devuelve
   * los mismos datos que /login (sin el token, que va en cookie httpOnly).
   */
  static async changeExpiredPassword({ username, oldPassword, newPassword }) {
    try {
      const result = await ApiService.post("/auth/change-password", {
        username,
        oldPassword,
        newPassword,
      });
      return result.data;
    } catch (error) {
      const msg = error?.response?.data?.resp || "No se pudo cambiar la contraseña. Intentá nuevamente.";
      throw new Error(msg);
    }
  }
}

export default AuthService;
